import React from "react";
import "../../../Tabs.css";

const toLocalDateString = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// 마감일까지 남은 달력일. 당일 0, 내일이면 1.
export const getDaysUntilEndDate = (endDate, now = new Date()) => {
  if (!endDate) return null;
  const endDateStr = String(endDate).split("T")[0];
  const endMidnight = new Date(`${endDateStr}T00:00:00`);
  const nowMidnight = new Date(`${toLocalDateString(now)}T00:00:00`);
  return Math.floor((endMidnight - nowMidnight) / (1000 * 60 * 60 * 24));
};

// 당일 오늘마감, 내일 2일, 모레 3일 (남은 일수 + 1)
export const formatEndDateRemainingLabel = (endDate, now = new Date()) => {
  const daysUntilEnd = getDaysUntilEndDate(endDate, now);
  if (daysUntilEnd === null) return "-";
  if (daysUntilEnd < 0) return "종료";
  if (daysUntilEnd === 0) return "오늘 마감";
  return `${daysUntilEnd + 1}일`;
};

const RemainingDaysBadge = ({ startDate, endDate, status }) => {
  // 광고 진행 상태에 따른 잔여기간 계산 함수
  const calculateRemainingDays = (startDate, endDate, status) => {
    // ✅ 승인 대기중인 경우 먼저 처리
    if (status === "PENDING") {
      return "승인대기중";
    }

    // ✅ 일시정지인 경우 먼저 처리
    if (status === "PAUSED") {
      return "일시정지";
    }

    // ✅ 광고 완료인 경우 먼저 처리
    if (status === "DONE") {
      return "종료";
    }

    // ✅ 반려된 경우 먼저 처리
    if (status === "REJECTED") {
      return "반려";
    }

    if (!endDate) return "-";

    return formatEndDateRemainingLabel(endDate);
  };

  // 광고 진행 상태에 따른 스타일 클래스
  const getRemainingClass = (startDate, endDate, status) => {
    // ✅ 승인 대기중인 경우 특별한 스타일
    if (status === "PENDING") {
      return "remaining-pending"; // 승인 대기중 전용 스타일
    }

    // ✅ 일시정지인 경우 특별한 스타일
    if (status === "PAUSED") {
      return "remaining-paused"; // 일시정지 전용 스타일
    }

    // ✅ 광고 완료인 경우 특별한 스타일
    if (status === "DONE") {
      return "remaining-expired"; // 광고 완료 전용 스타일 (빨간색)
    }

    // ✅ 반려된 경우 특별한 스타일
    if (status === "REJECTED") {
      return "remaining-rejected"; // 반려 전용 스타일 (분리된 CSS)
    }

    if (!endDate) return "remaining-normal";

    const daysUntilEnd = getDaysUntilEndDate(endDate);
    if (daysUntilEnd === null) return "remaining-normal";
    if (daysUntilEnd < 0) return "remaining-expired";
    // 오늘마감·2일·3일은 주황색, 4일 이상은 초록색
    if (daysUntilEnd <= 2) return "remaining-warning";
    return "remaining-normal";
  };

  return (
    <span
      className={`status-badge ${getRemainingClass(
        startDate,
        endDate,
        status
      )}`}
    >
      {calculateRemainingDays(startDate, endDate, status)}
    </span>
  );
};

export default RemainingDaysBadge;
